// import React, { useEffect, useRef, useState } from "react";
// import Video from "../../elements/video/video";
import "./head.scss";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
// import Menu_mobile from "../menu_mobile/Menu_mobile";
const Head = () => {
  // const [width, setWidth] = useState(window.innerWidth);
  // useEffect(() => {}, []);
  return (
    <div className="head">
      <Helmet>
        <title>Федерация Пауэрлитфинга Рязани</title>
        <meta
          name="description"
          content="Федерация Пауэрлифтинга Рязани и Рязанской области"
        />
      </Helmet>
      {/* <Video /> */}
      <Menu />
      {/* {width < 600 ? <Menu_mobile /> : <></>} */}
    </div>
  );
};

export default Head;
